export default __webpack_public_path__ + "static/770-6cd85a6a43785a1dd72d89f22e1d3b2d.gif";